
export class UploadSaveEvent {

	public id: string;
	public completed: boolean;
	public progress: number;

}